import styled from 'styled-components';

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  border: 1px solid ${({ hasError, theme }) =>
    hasError ? theme.colors.status.error : theme.colors.border.input};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  transition: all 0.2s;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.typography.fontFamily.base};

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.lighter};
  }

  &:focus {
    outline: none;
    border-color: ${({ hasError, theme }) =>
      hasError ? theme.colors.status.error : theme.colors.teal.main};
    box-shadow: 0 0 0 3px ${({ hasError, theme }) =>
      hasError ? `${theme.colors.status.error}20` : `${theme.colors.teal.main}20`};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.backgroundSecondary};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const TextArea = styled.textarea<{ hasError?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  border: 1px solid ${({ hasError, theme }) =>
    hasError ? theme.colors.status.error : theme.colors.border.input};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  transition: all 0.2s;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.typography.fontFamily.base};
  resize: vertical;
  min-height: 100px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.lighter};
  }

  &:focus {
    outline: none;
    border-color: ${({ hasError, theme }) =>
      hasError ? theme.colors.status.error : theme.colors.teal.main};
    box-shadow: 0 0 0 3px ${({ hasError, theme }) =>
      hasError ? `${theme.colors.status.error}20` : `${theme.colors.teal.main}20`};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.backgroundSecondary};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Select = styled.select<{ hasError?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  border: 1px solid ${({ hasError, theme }) =>
    hasError ? theme.colors.status.error : theme.colors.border.input};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.typography.fontFamily.base};

  &:focus {
    outline: none;
    border-color: ${({ hasError, theme }) =>
      hasError ? theme.colors.status.error : theme.colors.teal.main};
    box-shadow: 0 0 0 3px ${({ hasError, theme }) =>
      hasError ? `${theme.colors.status.error}20` : `${theme.colors.teal.main}20`};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.backgroundSecondary};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SearchInput = styled(Input).attrs({ type: 'search' })`
  padding-left: ${({ theme }) => theme.spacing.xl};
`;
